import * as ActionTypes from "../ActionTypes";

const initialState = {
    mpr_details: false,
    isLoadingMprDetails: false,
};

export const HiringRequestConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.ATS_MPR_DETAILS_GET_REQUEST:
            return {
                ...state,
                isLoadingMprDetails: true,
                mpr_details: false
            };
        case ActionTypes.ATS_MPR_DETAILS_UPDATE_REQUEST:
            return {
                ...state,
                isLoadingMprDetails: true,
            };
        case ActionTypes.ATS_MPR_DETAILS_GET_SUCCESS:
            return {
                ...state,
                isLoadingMprDetails: false,
                mpr_details: action.payload?.data?.data?.[0]?.fn_get_mpr_details,
            };
        case ActionTypes.ATS_MPR_DETAILS_UPDATE_SUCCESS:
            return {
                ...state,
                isLoadingMprDetails: false,
                mpr_details: action.payload?.data?.data?.[0]?.fn_update_mpr_details,
            };
        case ActionTypes.ATS_MPR_DETAILS_GET_ERROR:
        case ActionTypes.ATS_MPR_DETAILS_UPDATE_ERROR:
            return {
                ...state,
                isLoadingMprDetails: false,
            };
        default:
            return state;
    }
};

export default HiringRequestConfigReducer;
